import useApi from "_api/index";
import React from "react";

const CarStatusContext = React.createContext({ carStatuses: [] });

export const CarStatusProvider = ({ children }) => {
  const [carStatuses, setCarStatuses] = React.useState([]);

  React.useEffect(() => {
    const fetchCarStatuses = async () => {
      try {
        const response = await useApi.car.getCarStatusOptions();
        if (response.success) {
          const { data } = response;

          setCarStatuses(data);
        }
      } catch (error) {
        console.error("Error fetching car statuses:", error);
      }
    };
    fetchCarStatuses();
  }, []);

  return (
    <CarStatusContext.Provider value={{ carStatuses }}>
      {children}
    </CarStatusContext.Provider>
  );
};
export const useCarStatuses = () => React.useContext(CarStatusContext);
